import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CouponService } from '@fitness-force/api';
import { CouponType } from '@fitness-force/enum';
import { AppErrors } from '@fitness-force/errors';
import {
  CouponByMasterId,
  CouponCodes,
  GenerateCouponCodesRequest,
  OfferMaster,
} from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { BehaviorSubject } from 'rxjs';
import { SingleUseCouponComponent } from '../../../../offer/single-use-coupon/single-use-coupon.component';
import { VanityCouponComponent } from '../../../../offer/vanity-coupon/vanity-coupon.component';

@Component({
  selector: 'fitness-force-coupon-type',
  templateUrl: './coupon-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    ButtonModule,
    InputNumberModule,
    SingleUseCouponComponent,
    VanityCouponComponent,
    TranslateModule
  ]
})
export class CouponTypeComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);

  @Output() onAction = new EventEmitter();

  couponsModal = new BehaviorSubject(false);
  couponMaster: OfferMaster;
  coupons: CouponByMasterId[];
  formGroup: UntypedFormGroup;
  generateCouponsModal = new BehaviorSubject(false);
  couponArray: string[] = [];
  loadingBtn: boolean = false;
  showSingleUseCoupon = new BehaviorSubject(false);
  showVanityCoupon = new BehaviorSubject(false);

  constructor(
    private coupnService: CouponService,
    public formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private toastMessageService: ToastMessageService
  ) { }

  ngOnInit(): void { }

  getCouponCount(couponMaster: OfferMaster): number {
    let count = 0;
    couponMaster.coupon_codes.forEach(o => {
      count = o.max_redepmtion_count + count;
    })
    return count;
  }

  OpenCouponPopup(couponMaster: OfferMaster) {
    this.couponMaster = couponMaster;
    if (couponMaster.coupon_type == CouponType.SingleUse || couponMaster.coupon_type.toString() == CouponType[CouponType.SingleUse]) {
      this.showSingleUseCoupon.next(true);
    }
    else {
      this.showVanityCoupon.next(true);
    }
  }

  closePopup(event: any) {
    this.showSingleUseCoupon.next(false);
    this.showVanityCoupon.next(false);
    if (event)
      this.onAction.emit({
        action: 'reload',
        columnData: this.columnData,
      });
  }

}
